import React from 'react';
import ReactSelect, { SingleValue } from 'react-select';
import { MasterMedicineSelectorOption, MasterMedicineSelectorProps } from './interface';
import { useSearchMasterMedicines } from './useSearchMasterMedicines';
import useDebouncedSearchTerm from '../../hooks/useDebouncedSearchTerm';
import { isString } from './utils';
import useMasterMedicineOptions from './useMasterMedicineOptions';

function MasterMedicineSelector(props: Readonly<MasterMedicineSelectorProps>) {
  const { value: masterMedicinesId, onChange, disabled } = props;

  const { setValue, immediateValue, debouncedValue } = useDebouncedSearchTerm();
  const { masterMedicines } = useSearchMasterMedicines(debouncedValue);

  const { options, selectedOptions } = useMasterMedicineOptions({
    searchedMasterMedicines: masterMedicines,
    selectedMasterMedicinesId: masterMedicinesId
  });

  const handleSelectChange = (option: SingleValue<MasterMedicineSelectorOption>) => {
    if (!option?.value) {
      onChange(null);
    }

    if (isString(option?.value)) {
      onChange(option.value);
    }
  };

  return (
    <ReactSelect
      isDisabled={disabled}
      placeholder="Enter master medicine name"
      options={options}
      value={selectedOptions}
      inputValue={immediateValue}
      onInputChange={setValue}
      onChange={handleSelectChange}
    />
  );
}

export default MasterMedicineSelector;
